<template>
	<v-card>
		<v-card-title>
			Inviare le credenziali {{ cliente ? `al Cliente ${cliente.ragione_sociale}` : 'a tutti i tuoi clienti' }}?
		</v-card-title>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn
				color="tertiary"
				@click="closeSendCredentialsDialog()"
				:disabled="isSendingCredentials"
				class="black--text"
			>
				Annulla
			</v-btn>
			<v-btn
				color="secondary"
				@click="sendCredentials()"
				:loading="isSendingCredentials"
				:disabled="isSendingCredentials"
			>
				Invia
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
export default {
	props: ['cliente'],
	data() {
		return {
			// cliente: {
			// 	utente_id: null,
			// 	ragione_sociale: null
			// },
			isSendingCredentials: false
		}
	},
	
	created() {
		// if (this.value) this.cliente = Object.assign({}, this.value);
	},
	
	methods: {
		closeSendCredentialsDialog() {
			this.closeDialog();
			// this.cliente = {
			// 	utente_id: null,
			// 	ragione_sociale: null
			// }
		},
		closeDialog() {
			this.$emit('close');
		},
		sendCredentials() {
			this.isSendingCredentials = true;
			
			let config = {
				params: {
					utente_id: null,
				}
			}
			
			// se utente_id è diverso da null invio le credenziali al cliente selezionato
			if (this.cliente) config.params.utente_id = this.cliente.utente_id
			// altrimenti invio le credenziali a tutti i clienti dell'account manager loggato
			
			axios.get(`/api/utenti/send-credentials`, config)
				.then(() => {
					this.sendCredentialsDialog = false;
				})
				.finally(() => {
					this.closeDialog();
					this.isSendingCredentials = false;
				})
		}
	}
}
</script>

<style scoped>

</style>